
import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import * as sq from '~/store/modules/sq'
import * as faq from '~/store/modules/faq'

import AddressBar from '~/components/Plans/AddressBar.vue'
import PhoneCard from '~/components/Phone/PhoneCard.vue'
import PhoneSteps from '~/components/Phone/PhoneSteps.vue'
import WorldMap from '~/components/Icons/WorldMap.vue'
import PhoneMessage from '~/components/Icons/PhoneMessage.vue'
import FaqList from '~/components/Faq/FaqList.vue'

const SQ = namespace(sq.name)
const Faq = namespace(faq.name)

@Component({
  head() {
    return {
      title: `${this.brand.name} Residential Phone Plans from $9.95 p/m - ${
        this.brand.name
      }`,
      meta: [
        {
          hid: 'phone',
          name: 'description',
          content: `${
            this.brand.name
          } super-fast fibre from Opticomm. Unlimited data. Super-fast speeds. No lock In contracts. Plans from $54.95 per month.`
        }
      ]
    }
  },
  components: {
    FaqList,
    AddressBar,
    PhoneCard,
    PhoneSteps,
    WorldMap,
    PhoneMessage
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  }
})
export default class Phone extends Vue {
  @SQ.Getter
  sq

  @SQ.Getter
  addressChecked

  @Faq.Getter
  byType
}
